<template>
    <!-- 状態遷移を表示 -->
    <div class="container header-margin mx-auto">
        <div class="row state">
            <div class="col-md-2">送付先入力　→</div>
            <div class="col-md-2 active">個数指定　→</div>
            <div class="col-md-2 ">確認画面　→</div>
            <div class="col-md-2">お支払い</div>
        </div>

        <div class="title py-3">
            <h4 class="h4 font-weight-normal text-primary text-center py-3">
                購入数の確認
            </h4>
        </div>

        <form class="row form py-3" @submit.prevent="handleOnSubmit">
            <div class="col-md-4">
                <img src="./images/howto_pic.png" alt="DNA" />
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-4">KNOW ME 遺伝子検査キット</div>
                    <div class="col-md-8 form-inline">
                        <input type="number" min="1" required size="8" step="1" class="form-control" id="amount" v-model="formData.amount" @change="updateAmount">
                        <label for="amount" class="form-label">個</label>
                    </div>
                </div>
                
                <hr>

                <div class="row">
                    <div class="col-md-8 offset-md-4">
                        <div class="row">
                            <div class="col-md-4">小計</div>
                            <div class="col-md-6 text-right"><span>{{ formData.amount }}</span> 個 <span> {{ price | round }}</span> HEC</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">消費税 10%</div>
                            <div class="col-md-6 text-right"><span>{{ tax | round }}</span> HEC</div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-md-4">合計　</div>
                            <div class="col-md-6 text-right"><span>{{ total | round }}</span> HEC</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-row justify-content-center" v-if="errors" >
                        <div class="col-md-12">
                            <ul>
                                <li class="text-danger col col-12 text-left text-md-center" v-for="error in errors" :key="error">{{ error }}</li>
                            </ul>
                        </div>
                    </div>

                    <div class="form-row py-3 justify-content-center">
                        <div class="col-md-3">
                            <router-link :to="{ name: 'OrderAddress' }" class="text-center">
                                <span class="btn btn-light btn-block">戻る</span>
                            </router-link>
                        </div>

                        <div class="col-md-3 mt-2 mt-md-0">
                            <button v-on:submit.prevent type="submit" class="btn btn-primary btn-block">{{ $t('hec.policy.nextButton') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import userService from "../../services/UserService";
    import OrderService from "../../services/OrderService";
    import BN from 'bignumber.js'

    export default {
        name: 'OrderAmount',

        components: {
        },

        data() {
            return {
                formData: {
                    amount: 1,
                },
                errors: [],
                hec_price: 0,
            }
        },

        async created() {
            this.formData.amount = sessionStorage.getItem('amount');
            this.formData.hec_price = sessionStorage.getItem('hec_price');

            // 数値が入ってない場合に自動的に1にする
            if (this.formData.amount == 0 || this.formData.amount == undefined) {
                this.formData.amount = 1;
            }

            await this.fetchData();
            await this.updateAmount();
        },

        methods: {

            async fetchData() {
                try {
                    let balance = await Promise.all([
                        OrderService.getHecPriceByUSD(300),
                    ]);

                    this.hec_price = balance[0].data.price;
                    sessionStorage.setItem('hec_price', this.hec_price);
                } catch (err) {
                    console.log(err)
                }
            },

            calc() {
                return false;
            },

            handleOnSubmit() {
                this.$router.push('/dna/confirm');
            },

            updateAmount() {
                // 数値が入ってない場合に自動的に1にする
                if (this.formData.amount == 0) {
                    this.formData.amount = 1;
                }

                // 小数点が入った場合には切り上げる
                this.formData.amount = Math.ceil(this.formData.amount);

                sessionStorage.setItem('amount', this.formData.amount);
                sessionStorage.setItem('total', this.total);
                sessionStorage.setItem('price', this.price);
                sessionStorage.setItem('tax', this.tax);
            },
        },
        computed: {
            total() {
                return BN(this.price).plus(this.tax);
            },

            price() {
                return BN(this.formData.amount).times(this.hec_price);
            },

            tax() {
                return BN(this.price).div(10);
            }
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .btn-primary {
        color: #FFF !important;
    }
    .state {
        padding-bottom: 10px;
        
        color: #888;
    }
    .state .active {
        color: #451493;
    }
    #amount {
        width: 150px;
        margin-right: 20px;
    }
    #calc {
        font-size: 50;
    }
</style>
